import styled from "@emotion/styled";
import { ellipsis } from "polished";

import { ShadowToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IBoxContainerProps {
  width?: number;
}
export const BoxContainer = styled.div<IBoxContainerProps>`
  padding: 10px 0;
  width: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.width || "300"
  }px;
  min-width: 215px;
  background-clip: padding-box;

  border-radius: 4px;
  background-color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.backgroundColor
  };
  box-shadow: ${withVar(ShadowToken.PopOver)};
`;

interface IHeaderProps {
  withSeparator: boolean;
}

export const Header = styled.div<IHeaderProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 0 10px;
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      props.withSeparator &&
      `
padding-bottom: 10px;
border-bottom: 1px solid ${props.theme.borderColor};
`
  };
`;

interface IBodyProps {
  withSeparator?: boolean;
}
export const Body = styled.div<IBodyProps>`
  padding: 0 10px;
  font-size: 14px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor80
  };
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      props.withSeparator &&
      `
padding-top: 10px;
margin-top: 10px;
border-top: 1px solid ${props.theme.borderColor};
`
  };
`;

interface ITitleProps {
  empty?: boolean;
  floated?: boolean;
}

export const Title = styled.h3<ITitleProps>`
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      props.floated &&
      `
flex: inherit;
margin-left: 5px;
`
  };
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => !props.floated && "flex: 1"
  };

  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.empty ? props.theme.primaryColor50 : props.theme.primaryColor)
  };
  font-weight: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.empty ? "500" : "600")
  };
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.3px;
  ${ellipsis()};

  & + & {
    margin-left: 10px;
  }
`;

export const TextBody = styled.div`
  line-height: 20px;
  margin-top: 10px;
`;
